<template>
  <CenteredForm :width="378">
    <p class="title">Connection</p>
    <form>
      <div class="inputs">
        <ts-form-item :validation="$v.email">
          <ts-input placeholder="E-mail address" v-model.lazy="$v.email.$model" :disabled="loading"></ts-input>
        </ts-form-item>
        <ts-form-item :validation="$v.password">
          <ts-input
            placeholder="Password"
            show-password
            v-model.lazy="$v.password.$model"
            :disabled="loading"
          ></ts-input>
        </ts-form-item>
        <div class="errors">
          <div v-if="serverError === 'invalid_grant'">Invalid e-mail address or password</div>
        </div>
        <div class="actions">
          <ts-button :loading="loading" @click="handleSubmit">Log in</ts-button>
        </div>
        <div class="forgot-password">
          <router-link to="/forgot-password">Forgot password?</router-link>
        </div>
      </div>
    </form>
  </CenteredForm>
</template>

<style lang="scss" scoped>
.title {
  font-family: Roboto;
  font-size: 24px;
  color: #6d7587;
  text-align: center;
  margin-bottom: 28px;
}

.inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.errors {
  color: #f56c6c;
}

.actions {
  margin-top: 20px;
}

.link {
  text-decoration: none;
  margin-top: 16px;
  font-family: Roboto;
  font-size: 12px;
  color: #9aa5b7;
}

.forgot-password {
  margin-top: 16px;

  a {
    font-family: Roboto;
    font-size: 12px;
    text-align: center;
    text-decoration: none;
    color: #9aa5b7;
  }
}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ssoAuthentication, appId, isAuthenticated, redirectToSSO } from '@/api/workflow';

import CenteredForm from '@/components/layouts/CenteredForm.vue';

export default {
  components: {
    CenteredForm
  },
  beforeRouteEnter(to, from, next) {
    if (isAuthenticated()) {
      next();
      return;
    }

    ssoAuthentication()
      .then(config => {
        redirectToSSO();
      })
      .catch(error => {
        next();
      });
  },
  data() {
    return {
      loading: false,
      email: '',
      password: '',
      serverError: ''
    };
  },
  validations: {
    email: {
      required
    },
    password: {
      required
    }
  },
  methods: {
    ...mapActions(['login']),
    handleSubmit() {
      this.serverError = '';
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        this.login({ email: this.email, password: this.password })
          .then(user => {
            if (user && user.accounts && user.accounts.length) {
              this.$router.push({ name: 'creative-wall' }).catch(() => {});
            } else {
              this.$router.push({ name: 'connect-account' });
            }
          })
          .catch(err => {
            this.loading = false;
            if (err?.response?.data?.error === 'invalid_grant') {
              this.serverError = err.response.data.error;
            } else {
              console.error('Server error for connection call', err);
            }
          });
      }
    }
  }
};
</script>
